<template>
  <div class="corporateBox">
    <div
      v-for="corporate in corporates"
      class="c-row"
      @click="select(corporate)">
      {{corporate.name}}
      {{corporate.prefecture_name}}
      {{corporate.city_name}}
      {{corporate.street_address}}
    </div>
    <modal @close="show=false" v-if="show">
      <template slot="header">確認</template>
      <template slot="body">
        {{selectCorporate.name}}<br>
        {{selectCorporate.prefecture_name}}
        {{selectCorporate.city_name}}
        {{selectCorporate.street_address}}<br>
        を反映しますか？
      </template>
      <template slot="footer">
        <button class="btn btn-primary modal-default-button" @click="activate">反映</button>
        <button class="btn modal-default-button" @click="show=false">Close</button>
      </template>
    </modal>
  </div>
</template>
<style lang="scss" scoped>
  .corporateBox {
    max-height: 200px;
    overflow-y: scroll;
    margin-bottom: 20px;
    border: 1px solid #efefef;
  }

  .c-row {
    padding: 2px;
    border-bottom: 1px solid #efefef;
    cursor: pointer;

    &:hover {
      background-color: #efefef;
    }
  }

</style>
<script>
  export default {
    props: {
      corporates: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        show: false,
        selectCorporate: {}
      }
    },
    methods: {
      select (corporate) {
        this.selectCorporate = corporate
        this.show = true
      },
      activate () {
        this.show = false
        this.$emit('activate', this.selectCorporate)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CorporateRow.vue?ed697dbc